<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Resend Pending Invitations</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p>
      This will send the <b>{{ pendingEntries.length }}</b>
      pending invitation{{ pendingEntries.length === 1 ? '' : 's' }}
      to book the <b>{{ scheduledEvent.name }}</b> again. Each invitation goes
      out unchanged, with its current booking deadline, and the entries stay
      pending. Whether linked parents and guardians also receive it is chosen
      below, as it is on every send.
    </p>

    <ul>
      <li *ngFor="let entry of pendingEntries">
        <b>{{ entry.last_name }}, {{ entry.first_name }}</b>
        <span *ngIf="entry.booking_deadline !== null" class="text-nowrap">
          (Exp
          {{ dateStringFromISO8601(entry.booking_deadline, entry.time_zone) }},
          {{ timeStringFromISO8601(entry.booking_deadline, entry.time_zone) }})
        </span>
        <span *ngIf="entry.booking_deadline === null" class="text-nowrap">
          (No expiration)
        </span>
      </li>
    </ul>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
               id="resendPendingSendInviteToParentsAndGuardians"
               name="resendPendingSendInviteToParentsAndGuardians"
               [disabled]="loadingSave"
               [class.disabled]="loadingSave"
               [(ngModel)]="sendInviteToParentsAndGuardians">
        <label class="form-check-label"
               for="resendPendingSendInviteToParentsAndGuardians">
          Send invite to linked parents &amp; guardians
        </label>
      </div>
      <small class="form-text text-muted">
        If selected, the invite will be sent to any linked parents and guardians of the participant to accept or reject the invite on behalf of the participant. This is in addition to the participant's own email address.
      </small>
    </div>

    <app-age-restriction-bypass-warning [violations]="ageRestriction.violations"
                                        [(acknowledged)]="ageRestriction.acknowledged"
                                        [disabled]="loadingSave"></app-age-restriction-bypass-warning>

    <ng-container *ngIf="loadingSave">
      <h4>Loading...</h4>

      <div class="progress">
        <div class="progress-bar" role="progressbar" [style]="{width: getLoadingProgressPercentageStr() + '%'}"
             attr.aria-valuenow="{{ getLoadingProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSave"
            [disabled]="!resendAllowed()"
            [class.disabled]="!resendAllowed()"
            (click)="handleResend()">
      Resend {{ pendingEntries.length }} Invitation{{ pendingEntries.length === 1 ? '' : 's' }}
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
